import * as React from 'react';
import Svg, { SvgProps, Circle, Rect } from 'react-native-svg';

const QueueIcon40 = (props: SvgProps) => <Svg
  width='41'
  height='40'
  viewBox='0 0 41 40'
  fill='none'
  {...props}
>
  <Circle cx='20.5' cy='8' r='3' stroke='#0058AD' stroke-width='2' />
  <Circle cx='20.5' cy='18' r='3' stroke='#0058AD' stroke-width='2' />
  <Circle cx='20.5' cy='34' r='3' stroke='#0058AD' stroke-width='2' />
  <Rect x='8.5' y='26' width='24' height='2' rx='1' fill='#0058AD' />
</Svg>;

export default QueueIcon40;
